import { SCard } from 'app/components/StaycationUI';

import './Availability.scss';
import { ShowInInventoryField } from './_components/ShowInInventoryField';
import { StockConfigurationFields } from './_components/StockConfigurationFields';
import { StockOverrideModal } from './_components/StockOverrideModal';
import { StockTypeField } from './_components/StockTypeField';
import { TimeslotStockFields } from './_components/TimeslotStockFields';
import { useStockOverrideState } from './useStockOverrideState';

export const StockConfiguration = () => {
  const {
    isUnlimitedStock,
    handleUnlimitedCheckboxChange,
    handleShowInInventoryChange,
    overrideModal,
  } = useStockOverrideState();

  return (
    <SCard
      title="Stock"
      subtitle="Control activity visibility in the hotel inventory and set default stock rules (editable in the Extranet)."
      className="experience-form stock-configuration"
    >
      <ShowInInventoryField onChange={handleShowInInventoryChange} />
      <StockTypeField />
      <StockConfigurationFields
        isUnlimitedStock={isUnlimitedStock}
        onUnlimitedChange={handleUnlimitedCheckboxChange}
      />
      <TimeslotStockFields />
      <StockOverrideModal {...overrideModal} />
    </SCard>
  );
};
